export enum DocumentParentTypes {
	Route = "Route",
	Shipment = "Shipment",
	RouteShipment = "RouteShipment",
	RoutePartCMR = "RoutePartCMR",
	ManagementModelRequirementResponseDocument = 'ManagementModelRequirementResponseDocument',
	None = "None"
}